var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagePreferencesStatusSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "201px",
    height: "196px",
    viewBox: "0 0 201 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "submittedTitle"
  }, "Submitted") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "submittedTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ED2570",
    opacity: 0.100000001,
    cx: 99.0741455,
    cy: 187.381201,
    rx: 67.2118591,
    ry: 8.16776007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.611559,0.000105783335 L16.7754061,0.0012820672 L16.7754061,0.0012820672 C12.4502294,-0.0106508222 8.298106,1.69698068 5.23551703,4.74725806 C2.17292807,7.79753545 0.4516963,11.9396647 0.4516963,16.2593707 L0.4516963,127.326369 L200.795012,127.326369 L200.795012,15.1834532 C200.795118,6.79786356 193.997254,1.89027963e-12 185.611664,1.89182003e-12 C185.611629,1.89182004e-12 185.611594,1.24726979e-10 185.611559,0.000105783335 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "124.635969 175.622115 76.1952955 175.622115 79.2004114 151.035189 121.630854 151.035189"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#F0A0BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "124.635969 175.622115 76.1952955 175.622115 79.2004114 151.035189 121.630854 151.035189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.779376,187.037318 L65.9326286,187.037318 C64.6517042,187.048922 63.4514106,186.40852 62.7408529,185.334385 C62.0302952,184.26025 61.9053735,182.897352 62.4086659,181.710218 C64.4379469,177.45691 68.704204,174.749834 73.387165,174.74401 L128.32484,174.74401 C133.007801,174.749834 137.274058,177.45691 139.303339,181.710218 C139.806631,182.897352 139.681709,184.26025 138.971152,185.334385 C138.260594,186.40852 137.0603,187.048922 135.779376,187.037318 L135.779376,187.037318 Z",
    stroke: "#F0A0BE",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.092805,151.035189 C188.408193,151.046794 192.550918,149.37744 195.606575,146.395538 C198.662233,143.413635 200.379569,139.364355 200.379569,135.141478 L200.379569,127.326369 L0.4516963,127.326369 L0.4516963,135.141478 C0.4516963,139.364355 2.1690323,143.413635 5.22468953,146.395538 C8.28034676,149.37744 12.4230724,151.046794 16.7384597,151.035189 L184.092805,151.035189 Z",
    stroke: "#F0A0BE",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.498221,138.741727 C103.498221,140.196618 102.315259,141.37604 100.856002,141.37604 C99.3967452,141.37604 98.2137837,140.196618 98.2137837,138.741727 C98.2137837,137.286836 99.3967452,136.107413 100.856002,136.107413 C102.315259,136.107413 103.498221,137.286836 103.498221,138.741727 Z",
    fill: "#F0A0BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9554329,1.61648472e-13 L183.387805,1.61648472e-13 C192.381107,1.63549143e-13 199.671619,7.29051188 199.671619,16.2838141 L199.671619,24.4257211 L199.671619,24.4257211 L0.671618882,24.4257211 L0.671618882,16.2838141 C0.671618882,7.29051188 7.96213076,1.66853229e-13 16.9554329,1.61648472e-13 Z",
    fill: "#FFD3E2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.918218, 10.034452)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3108653,6.51352562 C31.1095257,6.51352562 32.5676281,5.05542324 32.5676281,3.25676281 C32.5676281,1.45810238 31.1095257,0 29.3108653,0 C27.5122049,0 26.0541025,1.45810238 26.0541025,3.25676281 C26.0541025,5.05542324 27.5122049,6.51352562 29.3108653,6.51352562 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2838141,6.51352562 C18.0824745,6.51352562 19.5405769,5.05542324 19.5405769,3.25676281 C19.5405769,1.45810238 18.0824745,0 16.2838141,0 C14.4851536,0 13.0270512,1.45810238 13.0270512,3.25676281 C13.0270512,5.05542324 14.4851536,6.51352562 16.2838141,6.51352562 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25676281,6.51352562 C5.05542324,6.51352562 6.51352562,5.05542324 6.51352562,3.25676281 C6.51352562,1.45810238 5.05542324,0 3.25676281,0 C1.45810238,0 0,1.45810238 0,3.25676281 C0,5.05542324 1.45810238,6.51352562 3.25676281,6.51352562 Z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 24.4257211,
    x2: 199.451696,
    y2: 24,
    stroke: "#F0A0BE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.379569,16.2593707 C200.379569,11.9396647 198.662233,7.79753545 195.606575,4.74725806 C192.550918,1.69698068 188.408193,-0.0106508222 184.092805,0.00121994537 L16.7384597,0.00121994537 C12.4230724,-0.0106508222 8.28034676,1.69698068 5.22468953,4.74725806 C2.1690323,7.79753545 0.4516963,11.9396647 0.4516963,16.2593707 L0.4516963,127.326369 L200.379569,127.326369 L200.379569,16.2593707 Z",
    stroke: "#F0A0BE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.361747, 38.142267)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFE8F0",
    fillRule: "nonzero",
    x: 16.2104635,
    y: 52.5506892,
    width: 60.0740708,
    height: 10.1818182,
    rx: 5.09090909
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.773658, 52.130402)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FD9BBF",
    strokeWidth: 1.01818182,
    fill: "#FFE8F0",
    x: 0.509090909,
    y: 0.509090909,
    width: 22.7603297,
    height: 9.90708022,
    rx: 4.95354011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46263102,1.92798742 C7.41476078,1.92798742 8.99727462,3.51050126 8.99727462,5.46263102 C8.99727462,7.41476078 7.41476078,8.99727462 5.46263102,8.99727462 C3.51050126,8.99727462 1.92798742,7.41476078 1.92798742,5.46263102 C1.92798742,3.51050126 3.51050126,1.92798742 5.46263102,1.92798742 Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFE8F0",
    fillRule: "nonzero",
    x: 16.2104635,
    y: 34.7325073,
    width: 60.0740708,
    height: 10.1818182,
    rx: 5.09090909
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.773658, 34.312220)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FD9BBF",
    strokeWidth: 1.01818182,
    fill: "#FFE8F0",
    x: 0.509090909,
    y: 0.509090909,
    width: 22.7603297,
    height: 9.90708022,
    rx: 4.95354011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46263102,1.92798742 C7.41476078,1.92798742 8.99727462,3.51050126 8.99727462,5.46263102 C8.99727462,7.41476078 7.41476078,8.99727462 5.46263102,8.99727462 C3.51050126,8.99727462 1.92798742,7.41476078 1.92798742,5.46263102 C1.92798742,3.51050126 3.51050126,1.92798742 5.46263102,1.92798742 Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFE8F0",
    fillRule: "nonzero",
    x: 16.2104635,
    y: 70.368871,
    width: 60.0740708,
    height: 10.1818182,
    rx: 5.09090909
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.773658, 69.948584)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FD9BBF",
    strokeWidth: 1.01818182,
    fill: "#FFE8F0",
    x: 0.509090909,
    y: 0.509090909,
    width: 22.7603297,
    height: 9.90708022,
    rx: 4.95354011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46263102,1.92798742 C7.41476078,1.92798742 8.99727462,3.51050126 8.99727462,5.46263102 C8.99727462,7.41476078 7.41476078,8.99727462 5.46263102,8.99727462 C3.51050126,8.99727462 1.92798742,7.41476078 1.92798742,5.46263102 C1.92798742,3.51050126 3.51050126,1.92798742 5.46263102,1.92798742 Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.88311589,1.90711336 L119.986366,1.90711336 C123.235521,1.90711336 125.869482,4.54107406 125.869482,7.79022925 L125.869482,19.0711336 L125.869482,19.0711336 L2.13162821e-14,19.0711336 L2.13162821e-14,7.79022925 C2.09183753e-14,4.54107406 2.6339607,1.90711336 5.88311589,1.90711336 Z",
    fill: "#FEE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.986366,1 C121.334801,1 122.55558,1.54656136 123.43925,2.43023153 C124.32292,3.3139017 124.869482,4.53468067 124.869482,5.88311589 L124.869482,5.88311589 L124.869482,89 L1,89 L1,5.88311589 C1,4.53468067 1.54656136,3.3139017 2.43023153,2.43023153 C3.3139017,1.54656136 4.53468067,1 5.88311589,1 L5.88311589,1 Z",
    stroke: "#F0A0BE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.210464, 7.628453)",
    stroke: "#ED2570",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 9.80563936,
    cy: 9.93743559,
    rx: 8.80563936,
    ry: 8.5947654
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "6.3036253 9.83534419 9.79737989 13.3641375 22.0626886 -3.13673219e-14"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePreferencesStatusSubmitted);
export default __webpack_public_path__ + "static/media/manage-preferences-status-submitted.41229d97d54ae55cfd68bb7a94619024.svg";
export { ForwardRef as ReactComponent };